import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Component({
  selector: 'app-dropdown-component',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.css']
})

export class DropdownComponent {

  @Input()
  dropdownValues: any;

  @Input()
  selectedValue: any;

  @Input()
  dynamicClass: any;

  @Input()
  minWidth!: any;

  @Input()
  isDropdownDisable!: boolean;

  @Output() selectedOption = new EventEmitter<any>();

  dropdownVisible: boolean = false;
  menuBtnClick: boolean = false;

  @HostListener('document:keydown.escape', ['$event'])
  onDocumentEscape(event: Event) {
    this.dropdownVisible = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClickClose(event: Event) {
    const targetElement = event.target as HTMLElement;
    if (this.dropdownVisible && !targetElement.closest('.dropdown')) {
      this.dropdownVisible = false;
    }
  }

  toggleDropdown(event: any) {
    event.stopPropagation();
    event.preventDefault();
    if (this.isDropdownDisable) {
      return;
    }
    this.dropdownVisible = !this.dropdownVisible
  }

  selectOption(option: any, event: any) {
    event.stopPropagation();
    this.dropdownVisible = false;
    this.selectedOption.emit(option)
  }

  handleChildClick(e: any) {
    if (e.target.id == "abcde") {
      this.menuBtnClick = true;
    }
  }
}
